<template>
  <div class='pa-4'>
    <br><br>
    <v-row >
      <v-col cols="10" offset="1">
        <div v-if="calendar_type == 'synchrotron'">
          <v-img :src=synchrotron_calendar_image_url
          ></v-img>
        </div>
        <div v-else-if="calendar_type == 'reactor'">
          <v-img :src=reactor_calendar_image_url
          ></v-img>
        </div>
      </v-col>
      <v-col cols="1">
        <template v-if="editable">
          <v-list-item class="d-flex flex-column align-start">
                <v-spacer style="height:10px;"></v-spacer>
                <v-btn
                  @click="new_cal_dialog = true"
                  outlined
                  width="100%"
                >обновить</v-btn>
          </v-list-item>
        </template>

      </v-col>
    </v-row>
    <br>
    <br>

  <v-dialog max-width="750px" v-model="new_cal_dialog">
    <v-card>
      <v-card-title>
        Обновить календарь
      </v-card-title>
      <v-card-text>
        <v-list-item-title>{{$t('jpg-upload')}}</v-list-item-title>
        <v-file-input
          v-model="file"
          label="Добавить файл"
          color="#15336d"
          :success="loadedFile"
          :loading="loadedFile"
          prepend-icon="mdi-paperclip">
        </v-file-input>
        <v-btn
          :disabled="!checkCommentFile"
          style="color: white"
          :color="$mainColor"
          @click="saveFile(file)"
        >{{$t('save')}}</v-btn>
        <v-btn color="green darken-1" text @click="new_cal_dialog = false">{{ $t('cancel') }}</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { DOMEN } from '../../vars'

export default {
  name: 'SynchrotronCalendar',
  components: {},

  data() {
    return {
      new_cal_dialog: false,
      checkFile: false,
      file: null,
      loadedFile: false,
      synchrotron_calendar_image_url: DOMEN+'/media/static/synchrotron.jpg',
      reactor_calendar_image_url: DOMEN+'/media/static/reactor.jpg',
      editable: false,
      calendar_type: 'synchrotron',
    };
  },

  beforeMount() {
    this.calendar_type = this.$route.name;
    this.GET_BASE_AVAILABLE_ACTIONS().then(res => {
      this.editable = res.is_moderator
    })
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.calendar_type = to.name;
    })
  },

  watch: {
    file(val) {
      if (val && typeof val === 'object') {
        this.validateFile(val) 
      }
    }
  },

  computed: {
    checkCommentFile() {
      if ((this.file !== null) && (this.file.length !== 0) && !this.loadedFile) return true
      else return false
    }
  },

  methods: {
    ...mapActions(['CALENDAR_UPLOAD', 'GET_BASE_AVAILABLE_ACTIONS']),

    async saveFile(data) {
      if(this.editable && this.checkFile) {
        this.loadedFile = true
        const files = new FormData();
        files.append('file', data);
        files.append('type', this.calendar_type);

        this.CALENDAR_UPLOAD(files)
          .then((res) => {
            this.file = null
            this.loadedFile = false
            if(this.calendar_type == 'synchrotron')
              this.synchrotron_calendar_image_url = this.synchrotron_calendar_image_url + '?timestamp=' + Math.floor(Math.random() * 100)
            else if(this.calendar_type == 'reactor')
              this.reactor_calendar_image_url = this.reactor_calendar_image_url + '?timestamp=' + Math.floor(Math.random() * 100)

            this.new_cal_dialog = false
          })
          .catch(() => this.loadedFile = false)
      }
    },

    validateFile(val) {
      const type = val.name.split('.').pop();        
      if (type === 'jpg'){
        if (val.size <= 6291456) {        
            this.checkFile =  true
        }
        else {
          this.$messageHelper(this.$t('Step2.6md'), 'error')
          this.checkFile = false
          this.file = ''          
        }
      }
      else{
        this.$messageHelper(this.$t('Step2.file_format_prohibited'), 'error')
        this.checkFile = false
        this.file = ''        
      }
    },

  },
};
</script>
